module.exports = __webpack_public_path__ + "static/media/u24b_3.f634e562.mp3";